import { render } from "./SearchProduct.vue?vue&type=template&id=e5c47776"
import script from "./SearchProduct.vue?vue&type=script&lang=js"
export * from "./SearchProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/quick-add-product/partials/SearchProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5c47776"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5c47776', __exports__)) {
    api.reload('e5c47776', __exports__)
  }
  
  module.hot.accept("./SearchProduct.vue?vue&type=template&id=e5c47776", () => {
    api.rerender('e5c47776', render)
  })

}


export default __exports__